import ScrollReveal from "scrollreveal";

export default function addScrollReveal() {
  const isPresent = document.querySelector("[data-reveal]");
  if (!isPresent) {
    return;
  }

  ScrollReveal().reveal("[data-reveal]", {
    easing: "cubic-bezier(0.25, 0.1, 0.25, 1)",
    scale: "1",
    viewFactor: "0",
    distance: "25px",
    delay: "200",
    mobile: false,
    reset: false,
    duration: 500,
  });
}
